import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Secretariat = types.compose(
  BaseEntity,
  types.model('Secretariat', {
    secretariatId: types.identifierNumber,
    name: types.string,
    code: types.string,
    address: types.maybe(types.string),
    zipCode: types.maybe(types.string),
    city: types.maybe(types.string),
    website: types.maybe(types.string),
    phoneNumber: types.maybe(types.string),
    mailAddress: types.maybe(types.string),
    language: types.string,
    isActive: types.boolean,
  }),
);
